import { AkebonoCoreModule } from '@akebono/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ResizeImagePipeModule } from 'src/app/pipes/resize-image-pipe/resize-image-pipe.module';
import { SwiperModule } from 'swiper/angular';

import { LotCarouselMainSliderItemComponent } from './components/lot-carousel-main-slider-item/lot-carousel-main-slider-item.component';
import { LotCarouselMainSliderMoveActionsComponent } from './components/lot-carousel-main-slider-move-actions/lot-carousel-main-slider-move-actions.component';
import { LotCarouselMainSliderVideoModalComponent } from './components/lot-carousel-main-slider-video-modal/lot-carousel-main-slider-video-modal.component';
import { LotCarouselMainSliderComponent } from './components/lot-carousel-main-slider/lot-carousel-main-slider.component';
import { LotCarouselThumbsItemComponent } from './components/lot-carousel-thumbs-item/lot-carousel-thumbs-item.component';
import { LotCarouselThumbsActionsComponent } from './components/lot-carousel-thumbs-actions/lot-carousel-thumbs-actions.component';
import { LotCarouselThumbsComponent } from './components/lot-carousel-thumbs/lot-carousel-thumbs.component';
import { LotCarouselComponent } from './lot-carousel.component';
import { LotWatchRequestBuyButtonModule } from '../lot-watch-request-buy-button/lot-watch-request-buy-button.module';

@NgModule({
  declarations: [
    LotCarouselComponent,
    LotCarouselMainSliderComponent,
    LotCarouselMainSliderMoveActionsComponent,
    LotCarouselThumbsComponent,
    LotCarouselThumbsActionsComponent,
    LotCarouselMainSliderItemComponent,
    LotCarouselThumbsItemComponent,
    LotCarouselMainSliderVideoModalComponent,
  ],
  exports: [LotCarouselComponent],
  imports: [
    CommonModule,
    SwiperModule,
    ResizeImagePipeModule,
    NzIconModule,
    NzButtonModule,
    NzGridModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzSpinModule,
    TranslateModule,
    AkebonoCoreModule,
    NzTabsModule,
    NzImageModule,
    LotWatchRequestBuyButtonModule,
  ],
})
export class LotCarouselModule {}
